import { useEffect, useState } from 'react';

/**
 * Shows the logged-in user's email + a "Log out" link (M20 T2).
 *
 * Fetches the current principal from /api/auth/me (session-gated). On the
 * dashboard the session is guaranteed valid; if the fetch 401s (e.g. expired
 * mid-session), the menu hides itself — the next gated call will bounce the
 * user to /login via RootRedirect.
 *
 * Rendered in the AppShell top bar so logout is one click from any surface.
 */
export function UserMenu() {
  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch('/api/auth/me')
      .then(async (res) => {
        if (!res.ok) return; // 401 → hide (no session to show)
        const data = (await res.json()) as { userEmail?: string | null; };
        if (cancelled) return;
        setEmail(data.userEmail ?? null);
      })
      .catch(() => {
        /* non-fatal — the menu just hides */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!email) return null;

  return (
    <div className="flex items-center gap-3">
      <span
        className="max-w-[180px] truncate text-xs text-ink-500"
        title={email}
      >
        {email}
      </span>
      <a
        href="/auth/logout"
        className="text-xs font-medium text-ink-400 transition-colors hover:text-warn-600"
      >
        Log out
      </a>
    </div>
  );
}
